import { render, staticRenderFns } from "./WrapperWrhsMngtReg.vue?vue&type=template&id=5a4c82e8"
import script from "./WrapperWrhsMngtReg.vue?vue&type=script&lang=js"
export * from "./WrapperWrhsMngtReg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports